const ROLLOUTS = {
    MUSTANGS_PRO_NAV_BAR_JOB_POST_EP: 'mustangs_pro_nav_bar_job_post_ep',
    MUSTANGS_MP_NAV_BAR_JOB_POST_EP: 'mustangs_mp_nav_bar_job_post_ep'
};

module.exports = {
    ROLLOUTS
};
